import { MyjbiGroupUserAttributeSpec, GroupUserAttributeTypeStatus } from '../types/myjbi-group.types';

export const defaultGULAs: MyjbiGroupUserAttributeSpec[] = [
  {
    groupUserAttribute: {
      id: 1,
      name: 'Email',
      slug: 'email',
      option: null,
      status: GroupUserAttributeTypeStatus.ACTIVE,
      groupUserAttributeType: {
        id: 2,
        type: 'email',
        option: null,
        status: GroupUserAttributeTypeStatus.ACTIVE,
      },
    },
    required: true,
    isDefault: true,
  },
  {
    groupUserAttribute: {
      id: 2,
      name: 'First Name',
      slug: 'first-name',
      option: null,
      status: GroupUserAttributeTypeStatus.ACTIVE,
      groupUserAttributeType: {
        id: 1,
        type: 'text',
        option: null,
        status: GroupUserAttributeTypeStatus.ACTIVE,
      },
    },
    required: true,
    isDefault: true,
  },
  {
    groupUserAttribute: {
      id: 3,
      name: 'Last Name',
      slug: 'last-name',
      option: null,
      status: GroupUserAttributeTypeStatus.ACTIVE,
      groupUserAttributeType: {
        id: 1,
        type: 'text',
        option: null,
        status: GroupUserAttributeTypeStatus.ACTIVE,
      },
    },
    required: true,
    isDefault: true,
  },
];
